<section class="Forums__Header">
  <div class="container container-forum">
    <div class="row">
      <div class="Forums__Header--text col-12">
        <h1 i18n>Agregar una nueva entrada</h1>
      </div>
    </div>
  </div>
</section>
<div class="Forums__Form">
  <div class="container container-forum">
    <div class="row">
      <div>
        <div>
          <p class="strong" i18n>Recomendaciones:</p>
          <ul>
            <li i18n><strong>Protege tu privacidad</strong>: No compartas información personal o sensible, como tu
              nombre completo, dirección, número de teléfono o cualquier otro dato que pueda identificarte</li>
            <li i18n><strong>Sé respetuoso</strong>: Trata a todos los miembros del foro con respeto y empatía. Todos
              estamos aquí para apoyarnos mutuamente.</li>
            <li i18n><strong>Busca ayuda cuando la necesites</strong>: Si sientes que necesitas apoyo emocional, te
              recordamos que puedes utilizar nuestra sección de <a class="underlined" [routerLink]="['/platform/therapists/']">Terapia y
                Asesoría Médica</a>. También puedes ponerte en contacto con tu coach para recibir orientación
              personalizada.</li>
          </ul>
        </div>
      </div>
      <div class="col-12">
        <form [formGroup]="this.forumForm" (submit)="sendEntry()">
          <div class="form-group">
            <label for="title" i18n>Título</label>
            <input type="text" class="form-control" [formControlName]="this.titleField" id="title"
              placeholder="Escribe un título para tu entrada" i18n-placeholder>
          </div>
          <div class="form-group">
            <label for="content" i18n>Contenido</label>
            <editor [apiKey]="this.editorApiKey" id="forumContentEntry" [formControlName]="this.contentField"
              [init]="this.editorConfiguration" toolbar="h2 h3 h4 bold italic underline image link">
            </editor>
          </div>
          <div class="my-4" *ngIf="isAdmin">
            <!-- Checkbox si quiere habilitar la traducción -->
            <div class="form-check form-check-inline p-0 m-1">
              <input [defaultChecked]="this.enableTranslationFields" class="form-check-input" type="checkbox"
                id="enableTranslation" name="enableTranslation" (change)="enableTranslation()">
              <label i18n for="enableTranslation">¿Quieres traducir tu entrada a inglés?</label>
            </div>
          </div>
          <div *ngIf="this.enableTranslationFields">
            <div class="form-group">
              <label for="title" i18n>Título en Inglés</label>
              <input type="text" class="form-control" [formControlName]="this.translationTitleField"
                id="titleTranslated" placeholder="Escribe un título para tu entrada">
            </div>
            <div class="form-group">
              <label for="content" i18n>Contenido en Inglés</label>
              <editor [apiKey]="this.editorApiKey" id="forumContentEntryTranslated"
                [formControlName]="this.translationContentField" [init]="this.editorConfiguration"
                toolbar="h2 h3 h4 bold italic underline image link">
              </editor>
            </div>
          </div>
          <button type="submit" class="btn btn-primary" i18n>Publicar</button>
        </form>
      </div>
    </div>
  </div>
</div>